import FeatureGates from '@atlaskit/feature-gate-js-client';
import { addFeatureFlagAccessed } from '@atlaskit/react-ufo/feature-flags-accessed';

import {
	ALLOWLIST_FFS_CUSTOM_EVENTS,
	FF_ALLOWLIST_FOR_PERF_METRICS,
} from '@confluence/browser-metrics/entry-points/featureFlagAllowListForMetrics';

const experimentPropAllowList = ['isEnabled', 'cohort', 'experience'];

export const addFeatureFlagAccessedForUFO = () => {
	// To add allowed feature flags to UFO payload
	FF_ALLOWLIST_FOR_PERF_METRICS.concat(ALLOWLIST_FFS_CUSTOM_EVENTS).forEach((flag) => {
		if (FeatureGates.isGateExists(flag)) {
			// eslint-disable-next-line confluence-feature-gating/use-recommended-utils
			const statsigFlag = FeatureGates.checkGate(flag);

			if (typeof statsigFlag !== 'object') {
				addFeatureFlagAccessed(flag, statsigFlag);
			}
		} else if (FeatureGates.isExperimentExists(flag)) {
			// eslint-disable-next-line confluence-feature-gating/use-recommended-utils
			const expValue = FeatureGates.getExperimentValue(flag, 'isEnabled', false);
			for (const prop of experimentPropAllowList) {
				if (expValue?.hasOwnProperty(prop)) {
					const fullFlagName = `${flag}:${prop}`;
					addFeatureFlagAccessed(fullFlagName, expValue[prop]);
				}
			}
		}
	});
};
